<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('user.User_info') }}</h5>    
    <p class="mb-0 text-sm">{{ $t('user.Mandatory_informations') }} *</p>

    <div class="multisteps-form__content">
      <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.E-mail') }} *</label>
              <input v-model="localFormData.email" type="text" class="form-control form-control-default" :placeholder="$t('user.E-mail')">
              <span v-if="v$.email.$error" class="text-sm text-danger">
                {{ v$.email.$errors[0].$message }}
              </span>
            </div>     
          </div>          
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label>{{ $t('user.Role') }} *</label> 
              <select id="roleId" v-model="localFormData.roleId" class="form-control form-control-default">
                  <option value="">{{ $t('user.Select_role') }}</option>
                  <option v-for="role in roles" :key="role.id" :value="role.name">
                    {{ translatedRole(role.name) }}
                  </option>
              </select> 
              <span v-if="v$.roleId.$error" class="text-sm text-danger">
                  {{ v$.roleId.$errors[0].$message }}
              </span>   
            </div>
          </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Initials') }}</label>
            <input v-model="localFormData.initials" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Initials')">            
          </div>
        </div>
        <!--
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Prefix') }}</label>
            <input v-model="localFormData.prefix" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Prefix')">            
          </div>
        </div>
        -->
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Firstname') }}</label>
            <input v-model="localFormData.firstName" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Firstname')">            
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Middlename') }}</label>
            <input v-model="localFormData.middleName" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Middlename')">            
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Lastname') }} *</label>
            <input v-model="localFormData.lastName" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Lastname')">
            <span v-if="v$.lastName.$error" class="text-sm text-danger">
              {{ v$.lastName.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Phone_number') }}</label>
            <input v-model="localFormData.phoneNumber" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Phone_number')">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Mobile_number') }}</label>
            <input v-model="localFormData.mobileNumber" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Mobile_number')">
            <!--<span v-if="v$.mobileNumber.$error" class="text-sm text-danger">
              {{ v$.mobileNumber.$errors[0].$message }}
            </span>-->
          </div>
        </div>
        <div class="col-4" v-show="localFormData.roleId === 'Keeper'">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Studbookcode') }}</label>
            <input v-model="localFormData.studbookCode" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Studbookcode')">
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="localFormData.roleId === 'Keeper'">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Inspector') }} *</label>
            <select id="inspectorId" v-model="localFormData.inspectorId" class="form-control form-control-default">
              <option value="">{{ $t('user.Select_inspector') }}</option>
              <option v-for="inspector in inspectors" :key="inspector.id" :value="inspector.id">
                {{ inspector.fullname }}
              </option>
            </select>
            <span v-if="v$.inspectorId.$error" class="text-sm text-danger">
                {{ v$.inspectorId.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="localFormData.roleId === 'Keeper' || localFormData.roleId === 'Inspector'">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.User_start_date') }}</label>
            <input v-model="localFormData.userStartDate" type="date" class="form-control form-control-default"
              :placeholder="$t('user.User_start_date')">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.User_end_date') }}</label>
            <input v-model="localFormData.userEndDate" type="date" class="form-control form-control-default"
              :placeholder="$t('user.User_end_date')">
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="localFormData.roleId === 'Keeper'">
        <p class="fw-bold">{{ $t('user.Select_which_information_you_want_to_share_within_your_association') }}</p>
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareName') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.shareName" id="shareName" name="shareName" />
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareEmail') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.shareEmail" id="shareEmail" name="shareEmail" />
            </div>
          </div>
        </div>
        <!--
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareAddress') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.shareAddress" id="shareEmail" name="shareAddress" />
            </div>
          </div>
        </div>
        -->
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareTelephone') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.shareTelephone" id="shareTelephone" name="shareTelephone" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="localFormData.roleId === 'Keeper'">
        <p class="fw-bold">{{ $t('user.Data_connection_RVO_and_GD') }}</p>
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.RVO_Connection') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.rvoConnection" id="rvoConnection" name="rvoConnection" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.RVO_Relationnumber') }} <span v-if="localFormData.rvoConnection"> *</span></label>
            <input v-model="localFormData.rvoRelationnumber" type="text" class="form-control form-control-default"
              :placeholder="$t('user.RVO_Relationnumber')">
            <span v-if="v$.rvoRelationnumber.$error" class="text-sm text-danger">
              {{ v$.rvoRelationnumber.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.GD_Connection') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.gdConnection" id="gdConnection" name="gdConnection" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">        
        <div class="col-6" v-show="localFormData.roleId === 'AssociationAdmin'">
          <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('user.Signature_image') }}</label>
              <div class="d-block mt-1 col-12">
                <div id="userSignature" class="form-control border dropzone"></div>
              </div>
          </div>
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto mb-0 js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from "dropzone";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import useVuelidate from '@vuelidate/core'
import { required, email as emailValidator, helpers } from '@vuelidate/validators'
import { ref, computed, reactive, watch, onMounted, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

export default {
  name: "UserInfo",
  props: {
    formData: Object,
    nextStep: Function,
    roles: Array,
    inspectors: Array,
    associations: Array,
    emitter: Object
  }, 
  setup(props, { emit }) {
   
      const dropzone = ref(null);
      const store = useStore();
      const dropzoneElementId = "#userSignature";

      const translatedRole = (name) => {
        return t(`roles.${name.toLowerCase()}`)
      }

      const userRoleName = computed(() => store.state.user?.roleName)

      const initializeDropzone = () => {    
        if (dropzone.value) return; // Prevent re-initialization

        Dropzone.autoDiscover = false;

        dropzone.value = new Dropzone(document.querySelector(dropzoneElementId), {      
          url: "https://httpbin.org/post", // Dummy URL
          maxFiles: 1,
          maxFilesize: 5, // in MB
          acceptedFiles: "image/*",
          addRemoveLinks: true,
          autoProcessQueue: false,
          dictDefaultMessage: "Sleep bestanden hierheen om te uploaden",
          dictRemoveFile: "Verwijder bestand", 

          init: function () {
            this.on("addedfile", (file) => {
              console.log("File added:", file)
              if (props.emitter) {
                props.emitter.emit("signImageUploaded", file)
              }
            })

            this.on("removedfile", () => {
              console.log("File removed")
              if (props.emitter) {
                props.emitter.emit("signImageUploaded", null)
              }
            })
          }
        });
      };

      const processQueue = () => {
        dropzone.value?.processQueue();
      };

      const getQueuedFiles = () => {
        return dropzone.value?.getQueuedFiles() || [];
      };

      onMounted(() => {
        initializeDropzone();
      });
      
      defineExpose({
        processQueue,
        getQueuedFiles
      });

      const { t } = useI18n()

      const localFormData = reactive({ ...props.formData, 
      userStartDate: props.formData.userStartDate ?? new Date().toISOString().split('T')[0] })

      const rules = computed(() => {
          return {
              lastName: { required: helpers.withMessage(t('common.Required'), required) },
              //mobileNumber: { required: helpers.withMessage(t('common.Required'), required) },
              roleId: { 
                  required: helpers.withMessage(t('common.Required'), required),
                  isSelected: helpers.withMessage(t('common.Select_a_role'), value => value !== '')
              },
              email: { 
                  required: helpers.withMessage(t('common.Required'), required),
                  email: helpers.withMessage(t('common.Invalid_email_address'), emailValidator) 
              },
              inspectorId: {
                required: helpers.withMessage(
                  t('common.Required'),
                  value => localFormData.roleId !== 'Keeper' || !!value
                )
              },
              rvoRelationnumber: {
                required: helpers.withMessage(
                  t('common.Required'),
                  () =>
                    localFormData.roleId !== 'AssociationAdmin' && localFormData.rvoConnection
                      ? !!localFormData.rvoRelationnumber
                      : true
                )
              }              
          }
      })
    
      const v$ = useVuelidate(rules, localFormData)
        
    watch(localFormData, () => {
      emit('update:formData', localFormData)
    }, { deep: true })

    const validateAndNextStep = async () => {
      v$.value.$touch() // Mark all fields as touched
      if (v$.value.$pending) {
        await v$.value.$validate() // Ensure validation completes
      }
      if (!v$.value.$invalid) {
        props.nextStep()
      }
    }

    return {
      translatedRole,
      localFormData,      
      v$,
      userRoleName,
      validateAndNextStep
    }
  },
  components: {      
    MaterialSwitch,
  },
  methods: {        
  }
}
</script>